import React from 'react';
import PropTypes from 'prop-types';
import { Col, KeyValue, NoValue, Row } from '@folio/stripes-components';
import useLocationName from '../../../../hooks/useLocationName';

function LocationFieldView({ fieldValues, locale, data, controlledVocab }) {
  const { name, label } = fieldValues;

  const { locationName } = useLocationName(data[name], controlledVocab);

  const fieldLabel = label.find((field) => field.locale === locale)?.value;

  return (
    <Row>
      <Col xs={12}>
        <KeyValue label={fieldLabel} value={locationName || <NoValue />} />
      </Col>
    </Row>
  );
}

LocationFieldView.propTypes = {
  fieldValues: PropTypes.object,
  locale: PropTypes.string,
  data: PropTypes.object,
  controlledVocab: PropTypes.object,
};

export default LocationFieldView;
